// constants
import * as filtersTypes from "../constants/services.constants";

// 5 status filter chips for the multi-select toolbar.
// `value` is the BE/ERP status string sent in `statuses[]`.
// `key` is the design key (used by the status color map).
// `label` is the user-facing chip text.
export const filters = [
  {
    value: filtersTypes.FILTERS_ACCEPTED,
    label: "Pending",
    key: "pending"
  },
  {
    value: filtersTypes.FILTERS_IN_PROGRESS,
    label: "In progress",
    key: "in_progress"
  },
  {
    value: filtersTypes.FILTERS_PAUSED,
    label: "Paused",
    key: "paused"
  },
  {
    value: filtersTypes.FILTERS_FINISHED,
    label: "Completed",
    key: "completed"
  },
  {
    value: filtersTypes.FILTERS_CANCELED,
    label: "Cancelled",
    key: "cancelled"
  }
];

export const defaultIncludedStatuses = filters.map(f => f.value);
